import layout from '@/layout'

export default {
  path: '/sys',
  component: layout,
  redirect: '/user/manage',
  name: 'menuPermission',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: '/sys/permissionmenu',
      component: () => import('@/views/sys/permission-menu/index.vue'),
      meta: {
        title: '菜单权限',
        icon: 'hamburger-button'
      }
    }
  ]
}
